import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource } from '@angular/material/table';
// import {ConfirmDialogComponent} from 'src/app/util/confirm-dialog/confirm-dialog.component';
import {Asamblea} from 'src/app/intranet/model/asamblea';
// import { Asistente } from 'src/app/model/asistente';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {SelectionModel} from '@angular/cdk/collections';
import {AsistenciaService} from '../asistencia.service';
import {Participante} from 'src/app/intranet/model/participante';
import {functionUtil} from 'src/app/util/functionConst';
import {AlertaService} from 'src/app/util/alerta.service';

@Component({
  selector: 'sura-registro-asistente',
  templateUrl: './registro-asistente-dialog.component.html',
  styleUrls: ['./registro-asistente-dialog.component.scss']
})
export class RegistroAsistenteDialogComponent implements OnInit {

  public bsqAsistenteForm: UntypedFormGroup;

  newArrayAsistente: Participante[] = [];
  // newAsamblea : Asamblea = new Asamblea();

  displayedColumns: string[] = ['CHECK', 'TIPO', 'NUMERODOCUMENTO', 'NOMBRESCOMPLETOS'];
  dataSource = new MatTableDataSource<Participante>(this.newArrayAsistente);
  selection = new SelectionModel<Participante>(false, []);
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  // registroAsistente: Asistente = new Asistente();
  // nombresCompletos:string = "";
  constructor(public dialogRegistroAsistente: MatDialogRef<RegistroAsistenteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Asamblea, private _asistenciaService: AsistenciaService,
              private alertaService: AlertaService) {
  }

  fnKeyDownAlphaNumeric = functionUtil.fnKeyDownAlphaNumeric;
  fnAlphaNumericMobile = functionUtil.fnAlphaNumericMobile;
  fnInputMaxLength = functionUtil.fnInputMaxLength;

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selecciona todas las filas si no están todas seleccionadas; de lo contrario limpia la selección. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.bsqAsistenteForm = new UntypedFormGroup({
      numeroDocumento: new UntypedFormControl('', [Validators.maxLength(13), Validators.maxLength(13),
        Validators.minLength(8),
        Validators.pattern('[a-zA-Z0-9]+')]),
      nombresCompletos: new UntypedFormControl('', [Validators.maxLength(80)])
    });
  }

  limpiarCamposTipoBsq(controlName: string) {
    if (controlName === 'numeroDocumento') {
      this.bsqAsistenteForm.controls.nombresCompletos.setValue('');
    } else if (controlName === 'nombresCompletos') {
      this.bsqAsistenteForm.controls.numeroDocumento.setValue('');
    }
  }

  hasErrorForm2() {
    return (this.bsqAsistenteForm.value.numeroDocumento === '' && this.bsqAsistenteForm.value.numeroDocumento.length === 0) &&
      (this.bsqAsistenteForm.value.nombresCompletos === '' && this.bsqAsistenteForm.value.nombresCompletos.length === 0) &&
      this.bsqAsistenteForm.invalid;
  }

  hasErrorForm(controlName: string) {
    let hasError = false;
    if (this.bsqAsistenteForm.controls[controlName].invalid || this.hasErrorForm2()) {
      hasError = true;
    }
    return hasError;
  }

  getErrorForm(controlName: string) {
    if (controlName.indexOf('numeroDocumento') >= 0) {
      return this.bsqAsistenteForm.controls[controlName].hasError('required') ? 'Campo Obligatorio' :
        this.bsqAsistenteForm.controls[controlName].hasError('maxlength') ? 'Max 13 caracteres' :
          this.bsqAsistenteForm.controls[controlName].hasError('minlength') ? 'Min. 8 caracteres' :
            this.bsqAsistenteForm.controls[controlName].hasError('pattern') ? 'Solo se acepta letras y números'
              : '';
    } else if (controlName.indexOf('nombresCompletos') >= 0) {
      return this.bsqAsistenteForm.controls[controlName].hasError('required') ? 'Campo Obligatorio' : '';
    }
  }

  buscarParticipante(valuesForm) {
    // _idAsamblea : number, _tipoBusqueda: string, _valorBusqueda:string
    let _tipoBusqueda = '';
    let _valorBusqueda = '';
    if (this.bsqAsistenteForm.value.numeroDocumento !== '' && this.bsqAsistenteForm.value.numeroDocumento.length > 0) {
      _tipoBusqueda = 'D';
      _valorBusqueda = this.bsqAsistenteForm.value.numeroDocumento;
    } else if (this.bsqAsistenteForm.value.nombresCompletos !== '' && this.bsqAsistenteForm.value.nombresCompletos.length > 0) {
      _tipoBusqueda = 'N';
      _valorBusqueda = this.bsqAsistenteForm.value.nombresCompletos;
    }
    this._asistenciaService.buscarTitularRepresentante(this.data.id, _tipoBusqueda, _valorBusqueda).then(list => {
      if (list instanceof Array) {
        this.llenarGrillaTitularRepresentante(list);
      }
    }).catch(err => {
      this.newArrayAsistente.splice(0, this.newArrayAsistente.length);
      this.dataSource._updateChangeSubscription();
      this.alertaService.error(err);
    });
  }

  llenarGrillaTitularRepresentante(arrayResult) {
    this.selection.clear();
    this.newArrayAsistente.splice(0, this.newArrayAsistente.length);
    for (let index = 0; index < arrayResult.length; index++) {
      const participante: Participante = new Participante();
      participante.id = arrayResult[index].idFoto;
      participante.nombreCompleto = arrayResult[index].nombres;
      participante.numeroDocumento = arrayResult[index].numeroDocumento;
      participante.tipoParticipante = arrayResult[index].tipo;
      participante.descTipoParticipante = participante.tipoParticipante === 'T' ? 'TITULAR' :
        participante.tipoParticipante === 'R' ? 'REPRESENTANTE' : '';
      this.newArrayAsistente.push(participante);
    }
    this.dataSource._updateChangeSubscription();
  }

  closeConfirmDialog() {
    this.dialogRegistroAsistente.close();
  }

  seleccionarAsistentes() {
    this.dialogRegistroAsistente.close(this.selection.selected[0]);
  }
}
